import { Stack } from '@mui/material';
import { useEffect, useState, useMemo, useCallback } from 'react';
import { InfoFeed } from 'orderme-api-integration-client';
import { BreadcrumbsBar } from '../breadcrumbs/breadcrumbsBar';
import { InfoFeedClient } from '../../helpers/client';
import { useParams } from 'react-router';
import { useRouteNavigator } from '../../routes/useRouteNavigator';
import { NewsItemRoute, NewsRoute } from '../../routes/allRoutes';
import useGetParameter from '../../hooks/useGetParameter';
import { RouterParam } from '../../helpers/routerParam';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { generateSlug } from '../../helpers/slugGenerator';
import { HtmlViewerContainer } from '../../controls/html/htmlViewerContainer';

export function NewsItem() {
  const routeNavigator = useRouteNavigator();
  const infoFeedClient = useMemo(() => new InfoFeedClient(), []);
  const params = useParams<'title'>();
  const idParam = useGetParameter(RouterParam.Id);
  const [infoFeedId, setInfoFeedId] = useState<string>();
  const [infoFeed, setInfoFeed] = useState<InfoFeed>();
  const links = useAppSelector((state: RootState) => state.linksState.news);

  const loadInfoFeed = useCallback(
    async (id: string) => {
      try {
        setInfoFeed(await infoFeedClient.get(id));
      } catch (error) {
        console.error(`Error fetching news by ID=${id}:`, error);
        setInfoFeed(null);
        routeNavigator.goHome();
      }
    },
    [infoFeedClient, routeNavigator]
  );

  useEffect(() => {
    const link = links.find((link) => link.id === idParam);
    if (link) {
      setInfoFeedId(link.dataId);
    } else {
      routeNavigator.goHome();
    }
  }, [idParam, links, routeNavigator]);

  useEffect(() => {
    if (infoFeedId) {
      loadInfoFeed(infoFeedId);
    } else {
      setInfoFeed(null);
    }
  }, [infoFeedId, loadInfoFeed]);

  useEffect(() => {
    if (infoFeed) {
      if (params.title !== generateSlug(infoFeed.title)) {
        routeNavigator.goToNewsItem(infoFeed.id, infoFeed.title);
      }
    }
  }, [infoFeed, params.title, routeNavigator]);

  return (
    <Stack direction="column" alignItems="center">
      <BreadcrumbsBar
        paths={[
          { path: NewsRoute, isLink: true },
          { path: NewsItemRoute, title: infoFeed?.title },
        ]}
      />
      <HtmlViewerContainer content={infoFeed?.description} isLoading={!infoFeed?.description} />
    </Stack>
  );
}
